import { gql } from '@apollo/client';
import { RECEIPT_ORDER_FRAGMENT } from '../../lib/core/orderFragment';

export const ORDER_QUERY = gql`
  ${RECEIPT_ORDER_FRAGMENT}
  query orderQuery($token: String!) {
    order(token: $token) {
      ...ReceiptOrder
    }
  }
`;
